(function () {
  if (window.__eacCardListenerAdded) return;
  window.__eacCardListenerAdded = true;

  // Clear the inline add-to-cart error on this card as soon as the customer
  // changes quantity or condition — the natural "fix" actions.
  function clearInlineError(fromEl) {
    var pf = fromEl.closest('product-form');
    if (!pf) return;
    if (typeof pf.handleInlineError === 'function') { pf.handleInlineError(); return; }
    var err = pf.querySelector('.csc-card__error');
    if (err) { err.classList.remove('is-visible'); err.textContent = ''; }
  }

  function updateQtyUI(wrap, max) {
    var input = wrap.querySelector('.csc-card__qty-input');
    var display = wrap.querySelector('.csc-card__qty-display');
    var minus = wrap.querySelector('.csc-card__qty-minus');
    var plus = wrap.querySelector('.csc-card__qty-plus');
    var cur = parseInt(input ? input.value : '1', 10);
    if (isNaN(cur) || cur < 1) cur = 1;
    if (cur > max) cur = max;
    if (input) input.value = String(cur);
    if (display) display.textContent = String(cur);
    if (minus) minus.disabled = cur <= 1;
    if (plus) plus.disabled = cur >= max;
  }

  function handleQtyBtn(btn) {
    var wrap = btn.closest('.csc-card__qty-wrap');
    if (!wrap) return;
    clearInlineError(wrap);
    var input = wrap.querySelector('.csc-card__qty-input');
    if (!input) return;
    var max = parseInt(wrap.dataset.max || '10', 10);
    var cur = parseInt(input.value, 10);
    if (isNaN(cur)) cur = 1;
    if (btn.classList.contains('csc-card__qty-minus')) {
      cur = Math.max(1, cur - 1);
    } else {
      cur = Math.min(max, cur + 1);
    }
    input.value = String(cur);
    updateQtyUI(wrap, max);
  }

  function selectRow(row) {
    var container = row.closest('.csc-cond-rows');
    if (!container) return;
    clearInlineError(container);

    container.querySelectorAll('.csc-cond-row').forEach(function (r) {
      r.classList.remove('selected');
      r.setAttribute('aria-checked', 'false');
    });
    row.classList.add('selected');
    row.setAttribute('aria-checked', 'true');

    var details = container.closest('.csc-card__details') || container.closest('product-form');
    if (!details) return;

    var priceCents = parseInt(row.dataset.price, 10);
    var maxQty = parseInt(row.dataset.qty, 10);
    if (isNaN(priceCents) || isNaN(maxQty) || maxQty < 1) return;

    var idInput = details.querySelector('.csc-card__variant-id');
    if (idInput) idInput.value = row.dataset.variantId;

    var dollars = Math.floor(priceCents / 100);
    var cents = priceCents % 100;
    var centsStr = cents < 10 ? '0' + cents : String(cents);

    var fromEl = details.querySelector('.csc-card__price-from');
    if (fromEl) fromEl.hidden = true;

    var dollarsEl = details.querySelector('.csc-card__price-dollars');
    var centsEl = details.querySelector('.csc-card__price-cents');
    if (dollarsEl) dollarsEl.textContent = dollars;
    if (centsEl) centsEl.textContent = centsStr;

    var qtyWrap = details.querySelector('.csc-card__qty-wrap');
    if (qtyWrap) {
      qtyWrap.dataset.max = String(maxQty);
      var qtyInput = qtyWrap.querySelector('.csc-card__qty-input');
      if (qtyInput) qtyInput.value = '1';
      updateQtyUI(qtyWrap, maxQty);
    }

    var stockEl = details.querySelector('.csc-card__stock');
    if (stockEl) {
      stockEl.textContent = row.dataset.qtyPlus ? '10+ available' : maxQty + ' available';
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.csc-card__qty-btn');
    if (btn) { handleQtyBtn(btn); return; }
    var row = e.target.closest('.csc-cond-row');
    if (row) selectRow(row);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var row = e.target.closest('.csc-cond-row');
    if (row) { e.preventDefault(); selectRow(row); }
  });
})();
